import { fetchFromServer, syncDependency, type DependencySyncConfig } from "./dependency-sync";
import { tags } from "@/plugins/LocalForagePlugin";
import { tagsSyncKey } from "@/types/products/product-keys";
import type { ApiFetchResponse } from "@tmi/types/api/fetch";
import type { TagApiResponse, Tags } from "@tmi/types/api/content-models";
import type { Tag } from "@tmi/types/entities";

const config: DependencySyncConfig<Tags, TagApiResponse, Tag> = {
    name: 'tag',
    store: () => tags,
    syncKey: tagsSyncKey,
    throttle: { hours: 4 },
    queryId: 'b9f293cd133e29ae59c3df8a3da55082',
    pageSize: 100,
    extractPayload: ( response: ApiFetchResponse<Tags> ) => response?.data?.tagCatalog?.tags,
    mapItem: ( t: TagApiResponse ): Tag => ( {
        id: t.id,
        publishedAt: t.published_at,
        name: t.name,
        slug: t.slug
    } )
};

export async function refreshTagsFromServer(): Promise<Tag[]> {
    return fetchFromServer( config );
}

export async function loadTagMap( tagsMap: Map<string, Tag> ): Promise<boolean> {
    return syncDependency( config, tagsMap );
}
